import React from 'react';
import { connectionStatusClasses } from "../common/tailwindClassnames";
import { HealthyStatusIcon, UnhealthyStatusIcon, DisabledStatusIcon, NeedsReviewStatusIcon } from "../common/ProjectIcons";

export const getConnectionStatus = (status: string, details_page: boolean, t: (key: string) => string) => {
    switch (status) {
        case "healthy":
            return { text: t("Healthy"), style: connectionStatusClasses.healthy(details_page), icon: <HealthyStatusIcon /> };
        case "unhealthy":
            return { text: t("Unhealthy"), style: connectionStatusClasses.unhealthy(details_page), icon: <UnhealthyStatusIcon /> };
        case "needs_review":
            return { text: t("Needs Review"), style: connectionStatusClasses.needsReview(details_page), icon: <NeedsReviewStatusIcon /> };
        case "disabled":
            return { text: t("Disabled"), style: connectionStatusClasses.disabled(details_page), icon: <DisabledStatusIcon /> };
        default:
            return { text: t("Unknown"), style: connectionStatusClasses.unknown(details_page), icon: <NeedsReviewStatusIcon /> };
    }
};